import TariffOptimalCircleIcon from '../../../assets/icons/TariffOptimalCircle.svg?react'
import TariffProfessionalCircleIcon from '../../../assets/icons/TariffProfessionalCircle.svg?react'
import TariffStartCircleIcon from '../../../assets/icons/TariffStartCircle.svg?react'
import TariffUnlimitedCircleIcon from '../../../assets/icons/TariffUnlimitedCircle.svg?react'
import {TariffType} from "../../../swagger/dto";

export const TARIFF_MAP = {
    [TariffType['START']]: {
        color: '#00BFFF',
        icon: <TariffStartCircleIcon />,
    },
    [TariffType['OPTIMAL']]: {
        color: '#03795F',
        icon: <TariffOptimalCircleIcon />,
    },
    [TariffType['PROFESSIONAL']]: {
        color: '#F86EB3',
        icon: <TariffProfessionalCircleIcon />,
    },
    [TariffType['INFINITY']]: {
        color: '#ED9121',
        icon: <TariffUnlimitedCircleIcon />,
    },
}
